<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="tasks"/>&nbsp;Editar tarea
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <sys-form :inputs="task_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: $route.params.type, params: { id: $route.params.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import tasksStatusService from '@/services/tasks_status'
import tasksService from '@/services/tasks'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'TaskUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      task_details: {
        title: {
          name: 'Título',
          hint: 'Título',
          value: '',
          type: 'text',
          disabled: true,
          size: 12
        },
        content: {
          name: 'Contenido',
          hint: 'Contenido',
          value: '',
          type: 'textarea',
          disabled: true,
          size: 12
        },
        status_id: {
          name: 'Estatus',
          hint: 'Selecciona un Estatus',
          value: null,
          type: 'select',
          size: 12,
          validate: 'required',
          options: []
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    tasksService.getById(id).then(res => {
      this.task = res.data
      Object.keys(this.task_details).forEach(key => {
        if (this.task_details[key].type != 'select') {
          this.task_details[key].value = this.task[key]
        }
      })
      tasksStatusService.list().then(res => {
        this.task_details.status_id.options = res.map(status => {
          return {value: status.id, text: status.description}
        })
      })
      this.task_details.status_id.value = { value: this.task.status_id, text: this.task.status_description }
    })
    this.loaded = true
  },

  methods: {
    saveForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const id = this.$route.params.id
          let taskInfo = { ...this.task_details }

          let body = this.processForm(taskInfo)
          let service = tasksService.updateById(id, body)

          this.sendForm(service).then(res => {
            this.$router.go(-1)
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tasks/TaskUpdate.vue